import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';

import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader'
 
  import { gsap } from 'gsap';
// import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
 import { ScrollTrigger } from 'gsap/ScrollTrigger';

//THREEJS

let controls;
let loader;

let miCanvas;
let scene;
let camera;

var cylinder;

let renderer;

// let logo3DOpaco;

// let logo3DOLineas;

// var arrLogos3D = [logo3DOpaco, logo3DOLineas];


var vertexShader = `
varying vec2 vUv;
void main()	{
  vUv = uv;
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
}
`;
var fragmentShader = `
	//#extension GL_OES_standard_derivatives : enable

varying vec2 vUv;
uniform float thickness;
   
float edgeFactor(vec2 p){
	vec2 grid = abs(fract(p - 0.5) - 0.5) / fwidth(p) / thickness;
	  return min(grid.x, grid.y);
}

void main() {
		
  float a = edgeFactor(vUv);
  
  vec3 c = mix(vec3(1), vec3(0), a);
  
  gl_FragColor = vec4(c, 1.0);
}
`;

 let miLuz;

 let particulas;

 let numPart = 15;

 let arrParticulas = [];
 
 let inParticulas;
 
 let contLogo ;
 
 let inContLogo ;
 
 
 
 let logo_up_FBX = {'mesh':'', rot:'', pos:''};
 
 let logo_down_FBX = {'mesh':'', rot:'', pos:''};
 
 let logo_medio_FBX = {'mesh':'', rot:'', pos:''};
 
 let logo_escalera_FBX = {'mesh':'', rot:'', pos:''};
 
 let arrLogosSep = [];
 
 
 let fbxLoader = new FBXLoader()
 



function do3D(){

	//console.log('DO BASICOOOOO 3DDDDD!!!'); 

	//console.log(document);

	  miCanvas= document.getElementById('cont_canvas');

	  if(miCanvas){
			//console.log('miCanvas');
			//console.log(miCanvas);

	  }


	scene = new THREE.Scene();
	// camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 1000 );


	scene.fog = new THREE.FogExp2( 0x000000, 0.00000025 );

	 let distCamera = 600;

	// camera = new THREE.PerspectiveCamera(70, window.innerWidth / window.innerHeight, 100, 1500);

	 camera = new THREE.OrthographicCamera( window.innerWidth / - 2, window.innerWidth / 2, window.innerHeight / 2, window.innerHeight / - 2, 1, 1000 );;

	 //

	 camera.position.z=  distCamera; // Posicíon de la cámara en Z

	 camera.fov = 2* Math.atan( (window.innerHeight/2) /  distCamera ) * (180/ Math.PI) ;

	 camera.position.x = -1*window.innerWidth/5;

	//  camera.lookAt(new THREE.Vector3(0, 0, 0));

 

	renderer = new THREE.WebGLRenderer({ alpha: true, antialias: true  });
	renderer.setSize( window.innerWidth, window.innerHeight );

 
	  renderer.shadowMap.enabled = true;
	  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
	  renderer.setPixelRatio(window.devicePixelRatio);
 

	miCanvas.appendChild( renderer.domElement );



	let geometry = new THREE.BoxGeometry( 100, 100, 100 );
	let material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
	let cube = new THREE.Mesh( geometry, material );
 

	camera.position.y = -150;

	//console.log('camera.position XXXXXXXXXXX');
	//console.log(camera.position);

 
	 var ambientLight = new THREE.AmbientLight(0xffffff);
	 scene.add(ambientLight);


 

    miLuz = new THREE.DirectionalLight( 0xffffff, 0.5 );
    miLuz.position.set( 1, 1, 1 );
    scene.add( miLuz );

	miLuz.castShadow = true;



	//cube.position.set(miLuz.position.x, miLuz.position.y, miLuz.position.z);

	cube.position.set(miLuz.position.x, miLuz.position.y, miLuz.position.z);
	//cube.position.copy(miLuz);


	//console.log('miLuz');
	//console.log(miLuz);

	contLogo =   new THREE.Group();

	inContLogo =   new THREE.Group();

	
	contLogo.add(inContLogo);


	//AÑADO LOGO

	scene.add(contLogo);



	particulas = new THREE.Object3D();

	inParticulas = new THREE.Object3D();

	//particulas.add(inParticulas);

	scene.add(inParticulas);

	var materialWhite = new THREE.MeshPhongMaterial({
		color: 0xffffff,
		shading: THREE.FlatShading,
		transparent:true, 
		opacity:1
		});

	var materialRed = new THREE.MeshPhongMaterial({
		color: 0xce0545,
		shading: THREE.FlatShading,
		transparent:true, 
		opacity:1
		});

	var logoLoad = 'logo.glb';

        // en el models del raiz

    //	logoLoad = 'logo_lineas.glb';

    logoLoad = 'dos_logos.glb';

    logoLoad = 'dos_logos_bloques.glb';

	logoLoad = 'logo_bloques_separados_hope.fbx';

 

	loader = new GLTFLoader().setPath( './models/' );

	if(document.location.hostname.indexOf('localhost') != -1){

		//console.log('SOY LOCALHOST');
		fbxLoader = new FBXLoader().setPath( 'http://'+document.location.hostname + '/escalante/models/' );

	}else{

		fbxLoader = new FBXLoader().setPath( 'https://'+document.location.hostname + '/models/' );
	}

	//console.log('FBX LOADER!!! ');
	//console.log(fbxLoader);

	 

	//loader.load( logoLoad, function ( gltf ) {

	fbxLoader.load( logoLoad, function ( gltf ) {

 

		scene.add(gltf);

		gltf.scale.set(50,50,50);


 

		gltf.children.forEach(element => {

			let tmpName = element.name;

			if(tmpName.indexOf('up')!=-1){			
				//console.log('meto up');
				logo_up_FBX.mesh = element;
				//logo_up.add(element); 
				arrLogosSep.push(logo_up_FBX);

			} 
			if(tmpName.indexOf('down')!=-1){
				//console.log('meto down');
				logo_down_FBX.mesh = element;
				//logo_down.add(element); 
				arrLogosSep.push(logo_down_FBX);

			}
			
			if(tmpName.indexOf('medio')!=-1){
				//console.log('meto medio');
				logo_medio_FBX.mesh = element;
				//logo_medio.add(element); 
				arrLogosSep.push(logo_medio_FBX);

			} 
			if(tmpName.indexOf('escalera')!=-1){
				//console.log('meto escalera');
				



				logo_escalera_FBX.mesh = element;
				//logo_escalera.add(element); 
				arrLogosSep.push(logo_escalera_FBX);

			}

			//console.log(typeof(element));
			

		});

		arrLogosSep.forEach(  (logo  )=>{

			let sigX = (Math.round(Math.random())-0.5)*2;
			let sigY = (Math.round(Math.random())-0.5)*2;
			let sigZ = (Math.round(Math.random())-0.5)*2;

			var rotX = Math.random()*sigX;
			var rotY = Math.random()*sigY;
			var rotZ =Math.random()*sigZ;

			logo.rot={'x':Math.PI*rotX, 'y':Math.PI*rotY, 'z':Math.PI*rotZ };

			  sigX = (Math.round(Math.random())-0.5)*2;
			  sigY = (Math.round(Math.random())-0.5)*2;
			  sigZ = (Math.round(Math.random())-0.5)*2;

			var posX = (5+ 5*Math.random())*sigX;
			var posY = (5+ 5*Math.random())*sigY;
			var posZ = (5+ 5*Math.random())*sigZ;

			logo.pos={'x':logo.mesh.position.x + posX, 'y':logo.mesh.position.y + posY, 'z':logo.mesh.position.z + posZ };

			//console.log('>>>>logo');
			//console.log(logo);



			inContLogo.add(logo.mesh);
			

		});

 
 

		miLuz.target = contLogo;
 
			
			var material2 = new THREE.ShaderMaterial({
			  uniforms: {
				thickness: {
					value: 1.5
				}
			  },
			  vertexShader: vertexShader,
			  fragmentShader: fragmentShader
			});


			
 
	 
		inContLogo.position.set(0,0,0);
		inContLogo.scale.set(12,12,12);


 
		//inContLogo.rotation.set(0 ,-Math.PI*0.15,  -Math.PI*0.15);

		


		//ROTATION

		/*

		gsap.to(logo_up_FBX.mesh.rotation, {
            scrollTrigger: {
            trigger: "body",
            start: "top top",
            end: "bottom top", 
            scrub: true,
            toggleActions: "restart pause resume pause"
        },
            y: logo_up_FBX.rot.y,
            z: logo_up_FBX.rot.z,
            x: logo_up_FBX.rot.x 
        });

        gsap.to(logo_down_FBX.mesh.rotation, {
            scrollTrigger: {
            trigger: "body",
            start: "top top",
            end: "bottom top", 
            scrub: true,
            toggleActions: "restart pause resume pause"
        },
        y: logo_down_FBX.rot.y,
        z: logo_down_FBX.rot.z,
        x: logo_down_FBX.rot.x 
        });

        gsap.to(logo_medio_FBX.mesh.rotation, {
            scrollTrigger: {
            trigger: "body",
            start: "top top",
            end: "bottom top", 
            scrub: true,
            toggleActions: "restart pause resume pause"
        },
        y: logo_medio_FBX.rot.y,
        z: logo_medio_FBX.rot.z,
        x: logo_medio_FBX.rot.x 
        });

        gsap.to(logo_escalera_FBX.mesh.rotation, {
            scrollTrigger: {
            trigger: "body",
            start: "top top",
            end: "bottom top", 
            scrub: true,
            toggleActions: "restart pause resume pause"
        },
        y: logo_escalera_FBX.rot.y,
        z: logo_escalera_FBX.rot.z,
        x: logo_escalera_FBX.rot.x 
        });

		*/



        //Position

		/*

        gsap.to(logo_up_FBX.mesh.position, {
            scrollTrigger: {
            trigger: "body",
            start: "top top",
            end: "bottom top", 
            scrub: true,
            toggleActions: "restart pause resume pause"
        },
            y: logo_up_FBX.pos.y,
            z: logo_up_FBX.pos.z,
            x: logo_up_FBX.pos.x 
        });

        gsap.to(logo_down_FBX.mesh.position, {
            scrollTrigger: {
            trigger: "body",
            start: "top top",
            end: "bottom top", 
            scrub: true,
            toggleActions: "restart pause resume pause"
        },
        y: logo_down_FBX.pos.y,
        z: logo_down_FBX.pos.z,
        x: logo_down_FBX.pos.x 
        });

        gsap.to(logo_medio_FBX.mesh.position, {
            scrollTrigger: {
            trigger: "body",
            start: "top top",
            end: "bottom top", 
            scrub: true,
            toggleActions: "restart pause resume pause"
        },
        y: logo_medio_FBX.pos.y,
        z: logo_medio_FBX.pos.z,
        x: logo_medio_FBX.pos.x 
        });

        gsap.to(logo_escalera_FBX.mesh.position, {
            scrollTrigger: {
            trigger: "body",
            start: "top top",
            end: "bottom top", 
            scrub: true,
            toggleActions: "restart pause resume pause"
        },
        y: logo_escalera_FBX.pos.y,
        z: logo_escalera_FBX.pos.z,
        x: logo_escalera_FBX.pos.x 
        });


			*/

 
		clonarLogo(inContLogo);

		var sigOriX = (Math.round(Math.random())-0.5)*2;
		var sigOriY = (Math.round(Math.random())-0.5)*2;
		var sigOriZ = (Math.round(Math.random())-0.5)*2;


		inContLogo.rotation.set(0 ,-Math.PI*Math.random(),  -Math.PI*Math.random());

		inContLogo.position.set(Math.random()*100*sigOriX,Math.random()*100*sigOriY,Math.random()*100*sigOriZ);


		arrClonesLogo.forEach(logo => {

			let ranDist = 50 + Math.random()*200;

			gsap.to(logo.position, {
				scrollTrigger: {
				trigger: "body",
				start: "top top",
				end: "bottom top", 
				scrub: true,
				toggleActions: "restart pause resume pause"
			},
			y: "+="+ranDist,
			z: logo.position.z,
			x: logo.position.x 
			});
	
			
		});

		 

		// gsap.to(inParticulas.rotation, {
		// 	scrollTrigger: {
		// 	trigger: "body",
		// 	start: "top top",
		// 	end: "bottom top", 
		// 	scrub: true,
		// 	toggleActions: "restart pause resume pause"
		//   },
		// 	y: Math.PI* -0.01,
		// 	z: Math.PI* -0.01,
		// 	x: Math.PI * -0.01,
		//   });

 
 

		animate();

		//  hazParticulas();

		loadTextures();

	} );	
 



}

function assignSRGB ( texture )   {

	//texture.colorSpace = THREE.SRGBColorSpace;

	materialSVG  = new THREE.MeshBasicMaterial( { map:texture, reflectivity:0, lightMapIntensity :0,  transparent: true  } );

	//hazParticulas();

};

let textureLoader;// = new THREE.TextureLoader();
let cir1;
let materialSVG;

var img = new Image();

//http://localhost/escalante/models/circulo.svg

/*
<svg id="Capa_1" data-name="Capa 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000"><circle fill="#b50038" cx="500" cy="500" r="500"/></svg>
*/

// let svg = `
// <svg width="500" height="500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">
//    <circle fill="#b50038" cx="250" cy="250" r="250"/>
// </svg>`;

// let blob = new Blob([svg], {type: 'image/svg+xml'});

var circulo;
function loadTextures(){

	

	textureLoader = new THREE.TextureLoader();



	if(document.location.hostname.indexOf('localhost') != -1){

		//console.log('SOY LOCALHOST');
		circulo = new FBXLoader().setPath( 'http://'+document.location.hostname + '/escalante/models/circulo_blue.svg' );

	}else{

		circulo = new FBXLoader().setPath( 'https://'+document.location.hostname + '/models/circulo_blue.svg' );
	}


	 cir1  = textureLoader.load( circulo, assignSRGB   ); 

	// cir1  = textureLoader.load( blob , assignSRGB ); 

}


function initRender(){
    tiempo  += 0.05;
    //console.log(tiempo);
    //miScroll.render();

    window.requestAnimationFrame(initRender )

}



var numClones = 10;

var arrClonesLogo = [];
var sepIni = 50;

var sepIniX = 200;
var sep3D = 300;
function clonarLogo(original){

	arrClonesLogo.push(inContLogo);

	let i = 0;

	for(var c= 0; c<numClones; c++){


		var mesh = original.clone();
		// changes made to position and rotation to not effect original
		var rad = Math.random()*Math.PI * 2;// * (i / 10);
		var sigX = (Math.round(Math.random()) - 0.5)*2  ;
		var sigY = (Math.round(Math.random()) - 0.5)*2  ;
		var sigZ = (Math.round(Math.random()) - 0.5)*2  ;
		var x = original.position.x + ( sepIniX + Math.random()*sep3D) *sigX// (50+ Math.random()*150)*sigX;
		var z = original.position.y  +(  Math.random()*sep3D/3 ) *sigY// (150+ Math.random()*150)*sigY;
		var y = original.position.z + ( sepIni  +Math.random()*sep3D ) *sigZ//(100+ Math.random()*100)*sigZ;

		//console.log('x, y , z');
		//console.log(x, y , z);

		mesh.rotation.set(Math.random()*Math.PI * 2, Math.random()*Math.PI * 2, Math.random()*Math.PI * 2);


		mesh.position.set(x, y, z);
		//mesh.lookAt(original.position);
		contLogo.add(mesh);

		arrClonesLogo.push(mesh);
		 i += 1;

	}

	


}

function clonarLogoRotado(original){

	let i = 0;

	for(var c= 0; c<15; c++){


		var mesh = original.clone();
		// changes made to position and rotation to not effect original
		var rad = Math.PI * 2 * (i / 10);
		var x = Math.cos(rad) * 60;
		var z = Math.sin(rad) * 60;
		mesh.position.set(x, 0, z);
		mesh.lookAt(original.position);
		contLogo.add(mesh);

		arrClonesLogo.push(mesh);
		 i += 1;

	}



}

//

//const geometry = new THREE.CylinderGeometry( 5, 5, 20, 32 ); 
// const material = new THREE.MeshBasicMaterial( {color: 0xffff00} ); 
// const cylinder = new THREE.Mesh( geometry, material ); scene.add( cylinder );

var centro ;
	const geoSphere = new THREE.SphereGeometry( 15, 32, 16 ); 
	const materialSphere = new THREE.MeshBasicMaterial( { color: 0xffff00 } ); 
function hazParticulas(){


 
	centro =    new THREE.Mesh( geoSphere, materialSphere ); 
	scene.add( centro );

	centro.visible = false;
 
	  var arrColores = [ 0xce005f,   0xe8c865,  0xf04b35,  0x3391c5,  0xd9e3db,  0x94d6a1];

	  arrColores=[0xb50038];

	for (var i = 0; i < numPart; i++) {

		var ranNum = Math.floor(Math.random()*arrColores.length  );


		//var geometry = new THREE.SphereGeometry( 5+Math.random()*15, 16, 16 );

		var radioCyl = 15 + Math.random() * 20 ;

		var geometry  = new THREE.CylinderGeometry( radioCyl, radioCyl, 1,20 ); 

		//var geometry = new THREE.PlaneGeometry( 5, 5 );

		//console.log(ranNum);
		/*
			shininess:0,
			shading: THREE.FlatShading,
			flatShading:true,
		*/

		var material = new THREE.MeshBasicMaterial ({
			color: arrColores[ranNum],
			

			side: THREE.DoubleSide
		  });


		////console.log('arrColores[ranNum]'  );

		////console.log(arrColores[ranNum]  );

		 var mesh = new THREE.Mesh(geometry, material);
		// var mesh = new THREE.Mesh(geometry, materialSVG);

		mesh.rotation.set(Math.PI/2, 0 , 0);

		console.log('GIRADO XXX - 15 -');

		//var mesh = new THREE.Sprite( materialSVG );

		//var ranScale = 25 + Math.random()*25;
		// var ranScale = 5 + Math.random()*5;
		// mesh.scale.set(ranScale,ranScale,ranScale);


		//mesh.position.set(Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5).normalize();


		var sigPX= ((Math.round(Math.random())-0.5)*2) *  (Math.random()*500);
		var sigPY= ((Math.round(Math.random())-0.5)*2)  * (Math.random()*500);
		var sigPZ= ((Math.round(Math.random())-0.5)*2)  * (Math.random()*500);

		mesh.position.set(Math.random()*sigPX, Math.random()*sigPY, Math.random()*sigPZ);


		var dA = Math.pow(  (mesh.position.x - centro.position.x)  , 2 );
		var dB = Math.pow(  (mesh.position.z - centro.position.z)  , 2 );
		let radio = Math.sqrt(dA + dB);
		let ang =   (mesh.position.z - centro.position.z)  / (mesh.position.x - centro.position.x) ;

		ang = Math.atan(ang);

		mesh.radio = radio;
		mesh.centro = new THREE.Vector2(centro.position.x, centro.position.z);

		mesh.velAng = Math.random()  * 0.003;

		mesh.finY = Math.random()*500 + 200;

		mesh.ang = ang;

		

 

		let pTmpX = Math.sin(  mesh.ang )  * mesh.radio ;
		let pTmpZ = Math.cos(  mesh.ang )  * mesh.radio ;

		mesh.position.set(pTmpX, mesh.position.y, pTmpZ);


		//console.log('>>>>> COLOCADO POST >>>>');

		//console.log(mesh.position);


		
		gsap.to(mesh, {
			scrollTrigger: {
			trigger: "body",
			start: "top top",
			end: "bottom top", 
			scrub: true,
			toggleActions: "restart pause resume pause"
		},
			radio: '+='+(Math.random()*200 + 200),

		});		

		gsap.to(mesh.position, {
			scrollTrigger: {
			trigger: "body",
			start: "top top",
			end: "bottom top", 
			scrub: true,
			toggleActions: "restart pause resume pause"
		},
			y: '+='+mesh.finY,

		});		

 
		arrParticulas.push(mesh);

 

		  scene.add(mesh);

	  }
}



function interact3D(pctScrolled , scrollTop){

 
}


function animate() {
	requestAnimationFrame( animate );

	// particulas.rotation.x += 0.00050;
	// particulas.rotation.y -= 0.00040;

	// inParticulas.rotation.x += 0.00050;
	// inParticulas.rotation.y -= 0.00040;

	// contLogo.rotation.x -= 0.00020;
	// contLogo.rotation.y += 0.00030;


	arrClonesLogo.forEach(logo => {

 	logo.rotation.x += 0.00050;
	logo.rotation.y -= 0.00040;

		
	});


	renderer.render( scene, camera );

	if(arrParticulas.length>0){
		for(var p=0; p<arrParticulas.length; p++){


			arrParticulas[p].ang+=arrParticulas[p].velAng;

			let pTmpX = Math.sin(  arrParticulas[p].ang )  * arrParticulas[p].radio ;
			let pTmpZ = Math.cos(  arrParticulas[p].ang )  * arrParticulas[p].radio ;

			arrParticulas[p].position.set( pTmpX, arrParticulas[p].position.y , pTmpZ  );;
	
		}

	}
 

}
//do3D

window.addEventListener('resize', generalResize);

function generalResize(){

	//THREEJS 

	anchoW = miCanvas.offsetWidth;
	altoW = miCanvas.offsetHeight;
	 renderer.setSize(anchoW , altoW);
	 camera.aspect = anchoW/altoW;
	 camera.updateProjectionMatrix();


	 //THREEJS 
}



export {do3D};

 